import angular from 'angular'

import component from './update-item.component'

let module = angular.module('updateItem', [])

.component('updateItem', component)

.name

export default module



// WEBPACK FOOTER //
// ./src/app/pages/vehicle/manage-my-rlink/components/update-item/index.js